<template lang="pug">
div
  .patient-history
    .patient-filters
      div.d-flex.align-center.px-4.py-2
        visit-filter-dropdown(@change="fetchFirstPage")
        diagnoses-filter-dropdown.ml-3(@change="fetchFirstPage")
        doctor-filter-dropdown.ml-3(@change="fetchFirstPage" type="visit")
        v-spacer
        y-button.mr-2(outlined color="neutral400" :background-color="view === 'list' ? 'var(--v-neutral300)' : null" prepend-icon="$yzi-list" icon-color="neutral700" icon-size="17" unset-min-width size="xxs" height="24" button-class="px-1" @click="view = 'list'")
        y-button.mr-2(outlined color="neutral400" :background-color="view === 'full' ? 'var(--v-neutral300)' : null" prepend-icon="$yzi-rows-01" icon-color="neutral700" icon-size="17" unset-min-width size="xxs" height="24" button-class="px-1" @click="view = 'full'")
        y-button(outlined color="neutral400" prepend-icon="$yzi-maximize-01" icon-color="neutral700" icon-size="17" unset-min-width size="xxs" height="24" button-class="px-1" @click="showAllPatientHistoryDialog = true")
      v-divider
    template(v-if="isFetching")
      v-skeleton-loader.px-4(type="list-item-three-line@3")
    template(v-else-if="!totalCount")
      div.d-flex.align-center.justify-center.fill-height(style="min-height: 200px;")
        div(align="center")
          v-icon(size="32" color="neutral500") $yzi-clipboard
          div.text-sm.font-medium.neutral700--text.mt-2 No visit found
          div.text-sm.neutral500--text.mt-1 No visit fit your filter criteria
    template(v-else)
      .patient-history-list
        .px-4.pb-4(v-if="view === 'full'")
          template(v-for="(history, idx) in patientHistories")
            patient-history-item(:patient-history.sync="history" @updated="fetchPatientHistory" :key="`full-${idx}`")
        .px-4.pb-4(v-if="view === 'list'")
          template(v-for="(history, idx) in patientHistories")
            patient-history-item-list(:patient-history.sync="history" @updated="fetchPatientHistory" :key="`list-${idx}`")
    .patient-history-pagination(v-if="totalCount")
      v-divider
      div.py-2.px-4
        yz-pagination(v-model="currentPage" :page-size.sync="pageSize" :count="totalCount" type="page" change-page-size menu-top arrow @input="pageChanged")
  .dialogs
    all-patient-history-dialog(v-if="showAllPatientHistoryDialog" :open.sync="showAllPatientHistoryDialog" :patient="patient" @updated="$emit('updated')")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VisitFilterDropdown from '@/components/clinic/consultation/VisitFilterDropdown.vue'
import DiagnosesFilterDropdown from '@/components/clinic/consultation/DiagnosesFilterDropdown.vue'
import DoctorFilterDropdown from '@/components/clinic/consultation/DoctorFilterDropdown.vue'
import PatientHistoryItem from '@/components/clinic/consultation/PatientHistoryItem.vue'
import PatientHistoryItemList from '@/components/clinic/consultation/PatientHistoryItemList.vue'
import AllPatientHistoryDialog from '@/components/clinic/dialogs/AllPatientHistoryDialog.vue'

export default {
  components: { VisitFilterDropdown, DiagnosesFilterDropdown, DoctorFilterDropdown, PatientHistoryItem, PatientHistoryItemList, AllPatientHistoryDialog },
  data () {
    return {
      isFetching: false,
      showAllPatientHistoryDialog: false,
      totalCount: 0,
      pageSize: 5,
      currentPage: 1,
      patientHistories: [],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      consultation: 'treatment/getConsultation',
      patient: 'treatment/getPatient',
      visitFilters: 'treatment/getVisitFilters',
      patientHistoryView: 'clinic/getPatientHistoryView',
    }),
    selectedVisits () {
      let ids = null
      if (this.visitFilters.visits) {
        ids = this.visitFilters.visits.map(m => m.lead_id).join(',')
      }
      return ids
    },
    beginDate () {
      let date = null
      if (this.visitFilters.dateRange && this.visitFilters.dateRange.length) {
        date = this.visitFilters.dateRange[0]
      }
      return date
    },
    endDate () {
      let date = null
      if (this.visitFilters.dateRange && this.visitFilters.dateRange.length > 1) {
        date = this.visitFilters.dateRange[1]
      }
      return date
    },
    doctors () {
      let ids = null
      if (this.visitFilters.doctors) {
        ids = this.visitFilters.doctors.map(m => m.value).join(',')
      }
      return ids
    },
    diagnoses () {
      let ids = null
      if (this.visitFilters.diagnoses) {
        ids = this.visitFilters.diagnoses.map(m => m.label).join(',')
      }
      return ids
    },
    view: {
      get () {
        return this.patientHistoryView
      },
      set (newValue) {
        this.$store.commit('clinic/setPatientHistoryView', newValue)
      }
    },
  },
  watch: {
    pageSize () {
      this.fetchFirstPage()
    },
  },
  mounted () {
    this.fetchPatientHistory()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPatientHistory () {
      let params = {
        page_size: this.pageSize,
        page: this.currentPage,
        ids: this.selectedVisits,
        begin: this.beginDate,
        until: this.endDate,
        providers: this.doctors,
        diagnoses: this.diagnoses,
        exclude_ids: this.consultation.lead,
      }
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/patients/${this.patient.id}/histories`, { params })
        .then(resp => {
          this.patientHistories = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
      this.checkParams()
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchPatientHistory()
    },
    pageChanged () {
      this.fetchPatientHistory()
    },
    checkParams () {
      if (this.$route.params?.viewAllHistory) {
        this.showAllPatientHistoryDialog = true
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.patient-filters {
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 10;
}
.patient-history-list {
  margin-bottom: 48px;
}
.patient-history-pagination {
  background-color: white;
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 10;
  border-radius: 0 0 10px 10px;
}
</style>